module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "div_autre",
    attrs: {
      "epub:type": "preamble"
    }
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-002"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_IX",
      "role": "doc-pagebreak",
      "title": "IX"
    }
  }, [_c('h1', {
    staticClass: "pre_tit",
    attrs: {
      "epub:type": "title",
      "lang": "en-US"
    }
  }, [_c('span', [_vm._v("List of Figures")])]), _c('div', {
    staticClass: "enc"
  }, [_c('div', {
    staticClass: "dev"
  }, [_c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "tab-001a"
    }
  }, [_c('div', {
    staticClass: "table-align"
  }, [_c('table', {
    staticStyle: {
      "border-collapse": "collapse",
      "border-spacing": "0px"
    }
  }, [_c('colgroup', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('col', {
    staticStyle: {
      "padding": "7px"
    }
  }), _c('col', {
    staticStyle: {
      "width": "77%"
    }
  })]), _c('tbody', [_c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/pre5#renvlnk-006"
    }
  }, [_c('b', [_vm._v("Figure 1.1.")])])])]), _c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(" The Collect for Whitsunday and Its Sources")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/p1chap2#renvlnk-009",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Figure 2.1.")])])])]), _c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(" Deuteronomy 30 and Romans 10")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/p1chap3#renvlnk-011",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Figure 3.1.")])])])]), _c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The Holy Communion Words of Pardon Compared")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/p2chap1#renvlnk-013",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Figure 4.1.")])])])]), _c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(" Sarum Breviary and 1552 Morning Prayer")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/p2chap1#renvlnk-014",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Figure 4.2.")])])])]), _c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(" The Law-Gospel Structure of Morning Prayer (1552)")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/p2chap1#renvlnk-015",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Figure 4.3.")])])])]), _c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The Law-Gospel Structure of Holy Communion (1552)")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/p2chap1#renvlnk-016",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Figure 4.4.")])])])]), _c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The Sarum Mass and Holy Communion (1552)")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/p2chap2#renvlnk-018",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Figure 5.1.")])])])]), _c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(" Cranmer’s Translation of the Collect for the Sunday Next before Easter")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/p2chap2#renvlnk-019",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Figure 5.2.")])])])]), _c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(" Cranmer’s Translation of the Collect for Purity")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/p2chap2#renvlnk-020",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Figure 5.3.")])])])]), _c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(" Cranmer’s Translation of the Collect for the Fourteenth Sunday after Trinity")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/p2chap2#renvlnk-021",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Figure 5.4.")])])])]), _c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Cranmer’s Translation of the Collect for the Thirteenth Sunday after Trinity")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/p2chap2#renvlnk-022",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Figure 5.5.")])])])]), _c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(" Cranmer’s Translation of the Second Collect for Evensong")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/p2chap2#renvlnk-023",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Figure 5.6.")])])])]), _c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(" Cranmer’s Translation of the Collect for the Fourth Sunday in Advent")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/p2chap2#renvlnk-024",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Figure 5.7.")])])])]), _c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Cranmer’s Translation of the Collect for the First Sunday after Epiphany")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/p2chap2#renvlnk-025",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Figure 5.8.")])])])]), _c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(" Cranmer’s Translation of the Inlumina Prayer")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/p2chap2#renvlnk-026",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Figure 5.9.")])])])]), _c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(" Cranmer’s Translation of the Collect for the Twelfth Sunday after Trinity")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_X",
      "role": "doc-pagebreak",
      "title": "X"
    }
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/p2chap2#renvlnk-027",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Figure 5.10.")])])])])]), _c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(" Cranmer’s New Collect for the First Sunday in Lent")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/p2chap2#renvlnk-028",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Figure 5.11.")])])])]), _c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(" Cranmer’s Translation of the Collect for the First Sunday after Trinity")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/p2chap2#renvlnk-029",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Figure 5.12.")])])])]), _c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(" Cranmer’s Redaction of Hermann’s Cologne Confession")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/p2chap2#renvlnk-030",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Figure 5.13.")])])])]), _c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Cranmer’s Redaction of Luther’s "), _c('i', [_vm._v("Taufbüchlein: ")]), _vm._v("The Flood Prayer")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/p2chap2#renvlnk-031",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Figure 5.14.")])])])]), _c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('i', [_vm._v("Salve salutaris hostia")]), _vm._v(" and Cranmer’s New Communion Prayers")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/p2chap3#renvlnk-033",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Figure 6.1.")])])])]), _c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(" Cranmer’s 1549 and 1552 Distribution Rubrics Compared")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/p2chap3#renvlnk-034",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Figure 6.2.")])])])]), _c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The Disappearance of “Altar” Terminology in Cranmer’s Liturgy")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/p2chap3#renvlnk-035",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Figure 6.3.")])])])]), _c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(" Robing Ceremonies in Sarum and the 1549 Book of Common Prayer")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/p2chap3#renvlnk-036",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Figure 6.4.")])])])]), _c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(" The Structure of Baptism in 1549 and 1552")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/p2chap3#renvlnk-037",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Figure 6.5.")])])])]), _c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(" The Holy Communion Words of Forgiveness in Sarum and Cranmer")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/p2chap3#renvlnk-038",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Figure 6.6.")])])])]), _c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(" Burial Rubrics of 1549 and 1552")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/p2chap3#renvlnk-039",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Figure 6.7.")])])])]), _c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(" The Rubrics for the Ordination of a Priest in 1550 and 1552")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/p2chap3#renvlnk-040",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Figure 6.8.")])])])]), _c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Theological-Experiential Shifts in Consecration and Reception Through Successive Liturgical Revisions (Colin Buchanan)")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/p2chap4#renvlnk-042",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Figure 7.1.")])])])]), _c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(" Cranmer’s 1549 and 1552 Burial Rite Compared")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/p2chap4#renvlnk-043",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Figure 7.2.")])])])]), _c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(" 1552 Morning Prayer Confession and Its Scripture References")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/p2chap4#renvlnk-044",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Figure 7.3.")])])])]), _c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The Law-Gospel Structure of the Book of Homilies")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/appen1#renvlnk-046",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Figure 8.1.")])])])]), _c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(" “I Surrender All” Transposed")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/appen1#renvlnk-047",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Figure 8.2.")])])])]), _c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I Have Decided to Follow Jesus” Transposed")])])])])])])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30c2cce0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre1.vue
// module id = 66
// module chunks = 0